export const getItem = (item) => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(item);
  }
  return null;
};

export const setItem = (itemName, data) => {
  return localStorage.setItem(itemName, data);
};

export const removeItem = (item) => {
  if (typeof window !== 'undefined') {
  return localStorage.removeItem(item);
  }
  return null;
};

export const getSessionItem = (item) => {
  if (typeof window !== 'undefined') {
    return window.sessionStorage.getItem(item);
  }
  return null;
};

export const setSessionItem = (itemName, data) => {
  return sessionStorage.setItem(itemName, data);
};

export const removeSessionItem = (item) => {
  return sessionStorage.removeItem(item);
};
